// extracted by mini-css-extract-plugin
export default {"ActivityContainer":"activity_ActivityContainer__HF3FP","Activities":"activity_Activities__3bpRS"};